export default [
  {
    key: 'name',
    label: 'Nama Lengkap',
    type: 'text',
    required: true,
    maxLength: 255,
  },
  {
    key: 'email',
    label: 'Email',
    type: 'email',
    required: true,
    maxLength: 255,
    notes: 'Password otomatis akan dikirim ke email ini setelah akun berhasil dibuat.',
  },
  {
    key: 'phone',
    label: 'Nomor HP',
    maxLength: 30,
    type: 'phone',
  },
  {
    key: 'role_ids',
    option_key: 'id',
    text: 'name',
    label: 'Role',
    notes: 'Dapat memilih lebih dari satu Role.',
    type: 'multiple',
    localSearch: true,
    initialOptions: true,
    actionSearch: 'roles/search',
    required: true,
  },
]
